import React, {useEffect, useState} from "react";
import {VsiBubble, VsiH4} from "../../../styled/App.styled";
import {useDataWithRoute, useTitleFromComponent} from "../../../utils/hooks";
import Grid from "../../../components/Grid";
import {Card} from "reactstrap";
import {useVsiAppContext} from "../../../stores/VsiApp";
import { databaseUnusedIndexesDefs } from "../../../utils/gridColumnDefs/databases/databaseIndexesDefs";

export default function DatabaseUnusedIndexes({title}) {
    useTitleFromComponent(title);

    const {theme, client, periodId} = useVsiAppContext();
    const [gridData, setGridData] = useState([]);
    const [data, {isLoading}] = useDataWithRoute(`/api/v6/report/database_unused_indexes_proc?client_id=${client.clientId}&period_id=${periodId}`);

    useEffect(() => {
        setGridData(data?.recordset)
    }, [data]);


    return (
        <Card className={`report-card p-2 nav-card-${theme}`}>
            <VsiH4>Database Unused Indexes</VsiH4>
            <VsiBubble>
                <Grid addStyle
                      gridText={'Double click a server to see more details'}
                      data={gridData}
                      isLoading={isLoading}
                      columnDefs={databaseUnusedIndexesDefs}/>
            </VsiBubble>
        </Card>
    );
}
